(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-policy-page"]) return;
  try {
    
  (function () {
    const body = document.querySelector('.custom-policy-page__body');
    if (!body) return;

    body.querySelectorAll('p').forEach((paragraph) => {
      if (paragraph.closest('table, ul, ol, blockquote')) return;

      const text = paragraph.textContent.trim();
      if (!text || text.length > 80) return;
      if (!/[A-Z]/.test(text) || text !== text.toUpperCase()) return;
      if (paragraph.querySelector('a, img, table')) return;

      paragraph.classList.add('custom-policy-page__heading');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGiftCardProduct(root) {
      if (!root || root.dataset.giftCardInitialized === 'true') return;
      root.dataset.giftCardInitialized = 'true';

      var select = root.querySelector('[data-gift-card-variant-select]');
      var variantId = root.querySelector('[data-gift-card-variant-id]');
      if (select && variantId) {
        var syncVariant = function () {
          variantId.value = select.value;
        };
        select.addEventListener('change', syncVariant);
        syncVariant();
      }

      var sendOn = root.querySelector('[data-gift-card-send-on]');
      if (sendOn) {
        var today = new Date();
        var maxDate = new Date();
        maxDate.setDate(today.getDate() + 90);
        var formatDate = function (date) {
          return (
            date.getFullYear() +
            '-' +
            String(date.getMonth() + 1).padStart(2, '0') +
            '-' +
            String(date.getDate()).padStart(2, '0')
          );
        };
        sendOn.min = formatDate(today);
        sendOn.max = formatDate(maxDate);
      }

      var offset = root.querySelector('[data-gift-card-offset]');
      if (offset) {
        offset.value = new Date().getTimezoneOffset().toString();
      }
    }

    function initAll() {
      document.querySelectorAll('[data-gift-card-product]').forEach(initGiftCardProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-gift-card-product]');
      initGiftCardProduct(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
